import { css } from '@styles/theme'

export const ModalStyles = {
	popupContainer: css({
		top: '50%',
		left: '50%',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(0, 0, 0, 0.8)',
		padding: '0px',
		height: 'auto',
		width: 'min-content',
		minWidth: '40vh',
		minHeight: '40vh',

		'@lg': {
			minWidth: '50vh',
			minHeight: '50vh',
		},

		'@resp': {
			minWidth: '80vh',
			minHeight: '80vh',
		},
	}),

	popupImage: css({
		width: 'auto',
		height: 'auto',
		maxWidth: '100%',
		maxHeight: '100%',
		objectFit: 'contain',
	}),
}
